var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticStyle: { color: "#a8abb2" } }, [
                  _vm._v("货品SKU"),
                ]),
              ]),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "line-clamp": "2",
                    "-webkit-line-clamp": "2",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.pickingDetail.csku))]
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticStyle: { color: "#a8abb2" } }, [
                  _vm._v("实际名称"),
                ]),
              ]),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "line-clamp": "2",
                    "-webkit-line-clamp": "2",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.pickingDetail.sgoods))]
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            [
              _c("template", { slot: "label" }, [
                _c("span", { staticStyle: { color: "#a8abb2" } }, [
                  _vm._v("实际库存"),
                ]),
              ]),
              _c(
                "span",
                {
                  staticStyle: {
                    display: "-webkit-box",
                    "-webkit-box-orient": "vertical",
                    "line-clamp": "2",
                    "-webkit-line-clamp": "2",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.inventory.nall))]
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            { attrs: { label: "*实际库存" } },
            [
              _c("el-input", {
                staticStyle: { width: "210px" },
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.surplus,
                  callback: function ($$v) {
                    _vm.surplus = $$v
                  },
                  expression: "surplus",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "*校正备注" } },
            [
              _c("el-input", {
                staticStyle: { width: "210px" },
                attrs: { placeholder: "请输入备注" },
                model: {
                  value: _vm.remake,
                  callback: function ($$v) {
                    _vm.remake = $$v
                  },
                  expression: "remake",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("提 交")]
          ),
          _c("el-button", { on: { click: _vm.onCancel } }, [_vm._v("关 闭")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }